'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadShopOptions = exports.LOAD_SHOP_OPTIONS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = shop;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SHOP_OPTIONS = exports.LOAD_SHOP_OPTIONS = 'tq-plus-admin/shopOptions/LOAD_SHOP_OPTIONS';

var initialState = {
  shopOptions: null
};

function shop() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case LOAD_SHOP_OPTIONS:
      {
        return (0, _extends3.default)({}, state, {
          shopOptions: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
}

var loadShopOptions = exports.loadShopOptions = function loadShopOptions(shopOptions) {
  return {
    type: LOAD_SHOP_OPTIONS,
    payload: shopOptions
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/rendering.js
// module id = 1661
// module chunks = 0